import React, { Component } from "react";
import { performLogout } from "../../utils/logout";

class SideBar extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.handleLogout = this.handleLogout.bind(this);
  }

  // Delegates to the shared helper so SideBar's logout button and the
  // per-profile-page logout buttons behave identically.
  async handleLogout(e) {
    if (e && e.preventDefault) e.preventDefault();
    await performLogout();
  }

  render() {
    const verifierName = localStorage.getItem("verifiername") || "User";
    const profileUrl   = this.props.profileLink || "verifier-profile";
    const stickyLayout = this.props.stickyLayout || false;
    const topOffset    = this.props.topOffset || 0;
    const { open }     = this.state;

    // Used by the user-card subtitle ("Admin Verifier" / "Admin" / "Verifier").
    const verifierType = localStorage.getItem("verifiertype");

    const initials = verifierName
      .split(" ").filter(Boolean).slice(0, 2)
      .map((w) => w[0].toUpperCase()).join("");

    // Left-pane menu = the page's own menus + a global "Add Accounts" link
    // (admins only), so account creation is reachable from every page.
    // De-duped by url so pages that already list it don't show it twice.
    const menus = Array.isArray(this.props.menus) ? this.props.menus.slice() : [];
    if (verifierType === "8" && !menus.some((m) => m && m.url === "/add-accounts")) {
      menus.push({ title: "Add Accounts", url: "/add-accounts" });
    }

    /* ─────────────────────────────────────────────
       OVERLAY mode  (Partner & device-home)
       Thin trigger strip → hover → slides over content
    ───────────────────────────────────────────── */
    if (stickyLayout) {
      return (
        <div
          style={{
            position: "fixed",
            left: 0,
            top: topOffset,
            height: topOffset ? `calc(100vh - ${topOffset}px)` : "100vh",
            zIndex: 500,
          }}
          onMouseEnter={() => this.setState({ open: true })}
          onMouseLeave={() => this.setState({ open: false })}
        >
          {/* Sliding panel */}
          <div style={{
            width: open ? 225 : 6,
            height: "100%",
            background: open ? "#2a3e4c" : "rgba(46,170,187,0.5)",
            transition: "width 0.22s ease",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            boxShadow: open ? "4px 0 24px rgba(0,0,0,0.45)" : "none",
          }}>

            {/* User card */}
            <div style={{
              display: "flex", alignItems: "center", gap: "10px",
              padding: "14px 14px 10px",
              borderBottom: "1px solid rgba(255,255,255,0.08)",
              background: "#1e2f3a",
              minWidth: 225, opacity: open ? 1 : 0,
              transition: "opacity 0.15s ease",
            }}>
              <div style={{
                width: 36, height: 36, borderRadius: "50%",
                background: "linear-gradient(135deg,#2eaabb,#1a6a72)",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: "14px", fontWeight: 700, color: "#fff", flexShrink: 0,
              }}>
                {initials}
              </div>
              <div style={{ overflow: "hidden" }}>
                <div style={{ color: "#fff", fontSize: "13px", fontWeight: 600, whiteSpace: "nowrap" }}>
                  {verifierName}
                </div>
                <div style={{ color: "#7ab8d8", fontSize: "10px", marginTop: 1 }}>
                  {verifierType === "8" ? "Admin Verifier" : verifierType === "1" ? "Admin" : "Verifier"}
                </div>
              </div>
            </div>

            {/* Nav links */}
            <div style={{ flex: 1, overflowY: "auto", padding: "8px 0", minWidth: 225 }}>
              {menus.map((menu, i) => {
                const isActive = window.location.pathname === menu.url;
                return (
                  <a key={i} href={menu.url} style={{
                    display: "flex", alignItems: "center", gap: "10px",
                    padding: "12px 16px",
                    color: isActive ? "#2eaabb" : "#c8dde0",
                    background: isActive ? "rgba(46,170,187,0.13)" : "transparent",
                    borderLeft: isActive ? "3px solid #2eaabb" : "3px solid transparent",
                    textDecoration: "none",
                    fontSize: "13px",
                    fontWeight: isActive ? 600 : 400,
                    whiteSpace: "nowrap",
                    transition: "background 0.15s",
                  }}
                    onMouseEnter={(e) => { if (!isActive) e.currentTarget.style.background = "rgba(255,255,255,0.07)"; }}
                    onMouseLeave={(e) => { if (!isActive) e.currentTarget.style.background = "transparent"; }}
                  >
                    <i className="zmdi zmdi-window-maximize" style={{ fontSize: "15px", flexShrink: 0 }}></i>
                    {menu.title}
                  </a>
                );
              })}
            </div>

            {/* Profile + Logout footer.
                The 4 admin links (Analysis Dashboard / Telemetry /
                Users by role / Assign Patients) used to live here as
                hardcoded entries with emoji icons. They now flow through
                the regular `menus` prop on each page so they render with
                the same styling as Patient List etc. — see VerifierHome
                menus.push() block and the menus={[…]} arrays on the four
                dashboard pages. */}
            <div style={{
              borderTop: "1px solid rgba(255,255,255,0.08)",
              padding: "8px 6px",
              background: "#1e2f3a",
              display: "flex", flexDirection: "column", gap: "2px",
              minWidth: 225,
            }}>

              {!this.props.hideProfile && (
                <a href={`/${profileUrl}`}
                  style={{ display: "flex", alignItems: "center", gap: "8px", padding: "8px 12px", borderRadius: "6px", color: "#a8d8ea", fontSize: "13px", textDecoration: "none", whiteSpace: "nowrap" }}
                  onMouseEnter={(e) => e.currentTarget.style.background = "rgba(255,255,255,0.07)"}
                  onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                >
                  <span style={{ fontSize: "15px" }}>👤</span><span>Profile</span>
                </a>
              )}
              {!this.props.hideLogout && (
                <a href="#" onClick={this.handleLogout}
                  style={{ display: "flex", alignItems: "center", gap: "8px", padding: "8px 12px", borderRadius: "6px", color: "#ff6b6b", fontSize: "13px", textDecoration: "none", whiteSpace: "nowrap" }}
                  onMouseEnter={(e) => e.currentTarget.style.background = "rgba(255,107,107,0.10)"}
                  onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                >
                  <span style={{ fontSize: "15px" }}>🚪</span><span>Log Out</span>
                </a>
              )}
            </div>

          </div>
        </div>
      );
    }

    /* ─────────────────────────────────────────────
       LEGACY fixed layout  (all other pages)
    ───────────────────────────────────────────── */
    return (
      <div
        className="fixed-sidebar-left"
        style={{ backgroundColor: "#2a3e4c", display: "flex", flexDirection: "column", height: "100%" }}
      >
        {/* User card */}
        <div style={{
          display: "flex", alignItems: "center", gap: "10px",
          padding: "14px 14px 10px",
          borderBottom: "1px solid rgba(255,255,255,0.08)",
          background: "#1e2f3a",
        }}>
          <div style={{
            width: 36, height: 36, borderRadius: "50%",
            background: "linear-gradient(135deg,#2eaabb,#1a6a72)",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: "14px", fontWeight: 700, color: "#fff", flexShrink: 0,
          }}>
            {initials}
          </div>
          <div style={{ overflow: "hidden" }}>
            <div style={{ color: "#fff", fontSize: "13px", fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {verifierName}
            </div>
            <div style={{ color: "#7ab8d8", fontSize: "10px", marginTop: "1px" }}>
              {localStorage.getItem("verifiertype") === "8" ? "Admin Verifier" : "Verifier"}
            </div>
          </div>
        </div>

        {/* Nav menu */}
        <ul className="nav navbar-nav side-nav nicescroll-bar"
          style={{ backgroundColor: "#2a3e4c", flex: 1, overflowY: "auto", margin: 0, padding: "4px 0" }}
        >
          {menus.map(function (menu, i) {
            const isActive = window.location.pathname === menu.url;
            return (
              <li key={i} style={{ marginBottom: 0 }}>
                <a href={menu.url} style={{
                  color: isActive ? "#2eaabb" : "white",
                  background: isActive ? "rgba(46,170,187,0.12)" : "transparent",
                  borderLeft: isActive ? "3px solid #2eaabb" : "3px solid transparent",
                  display: "block",
                }}>
                  <div className="pull-left" style={{ backgroundColor: "transparent" }}>
                    <i className="zmdi zmdi-window-maximize mr-20" style={{ backgroundColor: "transparent" }}></i>
                    <span className="right-nav-text" style={{ backgroundColor: "transparent" }}>{menu.title}</span>
                  </div>
                  <div className="pull-right" style={{ backgroundColor: "transparent" }}></div>
                  <div className="clearfix" style={{ backgroundColor: "transparent" }}></div>
                </a>
              </li>
            );
          })}
        </ul>

        {/* Profile + Logout footer.
            The 4 admin links used to be hardcoded here with emoji icons;
            they now flow through the regular `menus` prop so they render
            identically to Patient List. */}
        <div style={{
          borderTop: "1px solid rgba(255,255,255,0.08)",
          padding: "8px 6px", background: "#1e2f3a",
          display: "flex", flexDirection: "column", gap: "2px",
        }}>

          {!this.props.hideProfile && (
            <a href={`/${profileUrl}`}
              style={{ display: "flex", alignItems: "center", gap: "8px", padding: "8px 12px", borderRadius: "6px", color: "#a8d8ea", fontSize: "13px", textDecoration: "none", transition: "background 0.2s" }}
              onMouseEnter={(e) => e.currentTarget.style.background = "rgba(255,255,255,0.07)"}
              onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
            >
              <span style={{ fontSize: "15px" }}>👤</span><span>Profile</span>
            </a>
          )}
          {!this.props.hideLogout && (
            <a href="#" onClick={this.handleLogout}
              style={{ display: "flex", alignItems: "center", gap: "8px", padding: "8px 12px", borderRadius: "6px", color: "#ff6b6b", fontSize: "13px", textDecoration: "none", transition: "background 0.2s" }}
              onMouseEnter={(e) => e.currentTarget.style.background = "rgba(255,107,107,0.10)"}
              onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
            >
              <span style={{ fontSize: "15px" }}>🚪</span><span>Log Out</span>
            </a>
          )}
        </div>
      </div>
    );
  }
}

export default SideBar;
